import * as React from "react";
import FormaParteContainer from "../containers/formaparte-container";

export default function FormaPartePage() {
  return <FormaParteContainer></FormaParteContainer>;
}
